import React, { useState, useEffect } from 'react';
import styled, { keyframes } from 'styled-components';

// Список фраз, которые будут сменять друг друга
const LOADING_PHRASES = [
    'Проверяем наличие лекарств...',
    'Сверяем цены в аптеках...',
    'Подбираем лучшие варианты...',
    'Ищем бережно и быстро...',
    'Остались считанные секунды...'
];

export default function LoadingText({ phrases = LOADING_PHRASES }: { phrases?: string[] }) {
    const [index, setIndex] = useState(0);
    const [fade, setFade] = useState('in'); // 'in' или 'out'

    useEffect(() => {
        // Каждые 2 секунды запускаем процесс смены текста
        const interval = setInterval(() => {
            setFade('out'); // Сначала плавно скрываем текст

            // Через 300мс (время анимации исчезновения) меняем текст и проявляем его
            setTimeout(() => {
                setIndex((prevIndex) => (prevIndex + 1) % phrases.length);
                setFade('in');
            }, 300);

        }, 2300); // 2300мс общего цикла, чтобы текст успел побыть видимым

        return () => clearInterval(interval);
    }, []);

    return (
        <LoaderWrapper>
            <Spinner />
            <AnimatedText className={fade}>
                {phrases[index]}
            </AnimatedText>
        </LoaderWrapper>
    );
}

// --- Стилизация и анимации ---



const spin = keyframes`
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
`;

const LoaderWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 40px 20px;
  width: 100%;
  min-height: 200px;
`;

// Аккуратный аптечный спиннер (зеленый/бирюзовый)
const Spinner = styled.div`
  width: 40px;
  height: 40px;
  border: 3px solid #eef2f3;
  border-top: 3px solid #31708f; /* Цвет совпадает с нашей плашкой аналогов */
  border-radius: 50%;
  animation: ${spin} 1s linear infinite;
  margin-bottom: 16px;
`;

const AnimatedText = styled.p`
    font-size: 15px;
    color: #555555; /* Мягкий темно-серый цвет без использования CSS-переменных */
    font-weight: 500;
    margin: 0;
    transition: opacity 0.3s ease, transform 0.3s ease;
  
  &.in {
    opacity: 1;
    transform: translateY(0);
  }
  
  &.out {
    opacity: 0;
    transform: translateY(-5px);
  }
`;
